define('Magento_Catalog/js/back-to-top',[
    'jquery',
    'matchMedia',
], function ($, mediaCheck) {
    "use strict";

    $.widget('decimaDigital.backToTop', {
        options: {
            toTopButton: '.to-top-button',
        },
        _init: function () {
            var $widget = this;

            $($widget.options.toTopButton).on('click', function () {
                $widget.scrollToTop();
            });
        },

        scrollToTop: function () {
            $('html, body').animate({
                scrollTop: 0
            }, 500);
        }
    });

    return $.decimaDigital.backToTop;
});

